module.exports = __webpack_public_path__ + "static/media/indespension-1500455496.85f41c3f.jpg";